import { render, staticRenderFns } from "./GlNetworkInterfaces.vue?vue&type=template&id=61366b36&scoped=true"
import script from "./GlNetworkInterfaces.vue?vue&type=script&lang=js"
export * from "./GlNetworkInterfaces.vue?vue&type=script&lang=js"
import style0 from "./GlNetworkInterfaces.vue?vue&type=style&index=0&id=61366b36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61366b36",
  null
  
)

export default component.exports